import { mixpanel } from '@fiverr-private/obs';
import {
    BRIEF_SOURCE,
    MIXPANEL_EVENT_PROPERTIES,
    MIXPANEL_GENERIC_EVENTS,
} from '../../../../shared/mixpanel';
import { getDataFromStores } from '../../../../shared/utils';
import { BrandnameAndSlogan, IndustriesAndBusiness } from '../../shared/types';
import store from '../../store';

export const reportBannerBriefSubmitted = (
    { industries = [], business }: IndustriesAndBusiness = {},
    { brandName, slogan }: BrandnameAndSlogan = {},
    briefId: string
) => {
    const keywords = !!business && business.split(',');

    mixpanel.track(MIXPANEL_GENERIC_EVENTS.PAGE_ACTION, {
        ...getDataFromStores(
            store.listingsType,
            store.searchQuery,
            store.sourcePage,
            store.position,
            store.page
        ),
        [MIXPANEL_EVENT_PROPERTIES.ACTION]: 'Brief Submitted',
        [MIXPANEL_EVENT_PROPERTIES.CTA_CLICKED]: industries[0],
        [MIXPANEL_EVENT_PROPERTIES.INDUSTRY]: industries,
        [MIXPANEL_EVENT_PROPERTIES.INDUSTRY_COUNT]: industries.length,
        [MIXPANEL_EVENT_PROPERTIES.KEYWORDS]: keywords ? keywords : [],
        [MIXPANEL_EVENT_PROPERTIES.KEYWORDS_COUNT]: keywords
            ? keywords.length
            : 0,
        [MIXPANEL_EVENT_PROPERTIES.BRAND_NAME]: brandName,
        [MIXPANEL_EVENT_PROPERTIES.SLOGAN]: slogan,
        [MIXPANEL_EVENT_PROPERTIES.BRIEF_ID]: briefId,
        [MIXPANEL_EVENT_PROPERTIES.BRIEF_SOURCE]: BRIEF_SOURCE.MP_BRIEF,
    });
};
